import { Typography, Space } from 'antd';
import { displayFacDept } from '../../../utils';

const { Text } = Typography;

const selectUserOptionItemRender = ({
  user: { department, faculty, email },
  label,
}) => {
  return (
    <Space direction="vertical">
      {label}
      <Text type="secondary">{email}</Text>
      <Text type="secondary">
        {displayFacDept({
          department: department,
          faculty: faculty,
          prefix: false,
        })}
      </Text>
    </Space>
  );
};

export default selectUserOptionItemRender;
